import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.871 11.575 10.38 15h2.657l-1.02-1.394.001-.001-1.249-1.706h-.002L7.871 7.947v-.003L4.937 3.935h-.001L2.786 1H.13l2.928 4H1.871a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2l4 4v-3.425ZM7.871 1l-1.4 1.4 1.4 1.913V1Zm8 7a5.983 5.983 0 0 1-2.016 4.486l-1.189-1.624A4 4 0 0 0 9.871 4V2a6 6 0 0 1 6 6Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.871 8c0 .457-.153.878-.41 1.215l-1.59-2.17V6a2 2 0 0 1 2 2Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconMediaSoundOff16 = createIcon(IconComponent);